import React, {Component} from 'react';
import {Button, Form, Modal} from 'semantic-ui-react';
import DeliveryData from "../../data/DeliveryData";
import {showToast} from "../../actions/ToastAction";
import {connect} from "react-redux";
const C = require("../../constants");

class DeliveryOrder extends Component {

    constructor(props) {
        super(props);
        this.state = {
            delivery: props.delivery,
            sale: props.sale,
            delivery_man: props.delivery ? props.delivery.delivery_man.id:null,
            open: false,
            sending: false,
            channel: props.delivery ? props.delivery.channel:'other',
            delivery_men: []
        };
        this.handleSubmit = this.handleSubmit.bind(this)
    }

    componentWillMount(){
        DeliveryData.deliveryMen((response) => {
            let delivery_men = []
            response.map(delivery_man => delivery_men.push({key: delivery_man.user.id, text: delivery_man.user.full_name, value: delivery_man.user.id}))
            this.setState({delivery_men})
        });
    }

    handleClose = () => {
        this.setState({open: false});
    };

    handleOpenModal  = () => {
        this.setState({open: true});
    };

    handleChange = (e, { name, value }) => this.setState({ [name]: value })

    handleSubmit(event) {
        event.preventDefault();
        if (this.state.delivery_man === null) {
            this.setState({delivery_man_error: true});
        }else {
            let data = {
                id: this.state.delivery ? this.state.delivery.id:null,
                delivery_man: this.state.delivery_man,
                channel: this.state.channel,
                sale: this.state.sale
            };
            this.setState({loading: true});
            DeliveryData.updateDeliverySale(data, response =>{
                if(response.update){
                    this.setState({delivery: response.data})
                    this.props.showToast({message: 'Delivery Actualizado!', type: 'success'});
                    this.handleClose()
                }
            })
        }
    };

    render() {
        return (
            <React.Fragment>
                <Button
                    primary
                    icon='motorcycle'
                    fluid
                    labelPosition='left'
                    content={this.state.delivery ? `Repartidor: ${this.state.delivery.delivery_man.full_name}`: 'Sin Asignar Repartidor'}
                    loading={this.state.saving}
                    disabled={this.state.saving}
                    style={{marginTop:'1em'}}
                    onClick={ () => this.handleOpenModal()}
                />

                <Modal size='tiny' dimmer='inverted' open={this.state.open} onClose={this.handleClose}>
                    <Modal.Header>Repartidor</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <Form onSubmit={this.handleSubmit}>
                                <Form.Select label='Repartidor' options={this.state.delivery_men}
                                             name='delivery_man'
                                             onChange={this.handleChange}
                                             value={this.state.delivery_man} placeholder='Repartidor'
                                             error={this.state.delivery_man_error}/>
                                <Form.Select label='Canal' options={C.DELIVERY_CHANNEL}
                                             name='channel'
                                             onChange={this.handleChange}
                                             value={this.state.channel} placeholder='Canal' />
                            </Form>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.handleClose} content="Cancelar"/>
                        <Button primary icon='save' loading={this.state.sending} disabled={this.state.sending} labelPosition='left'
                                onClick={this.handleSubmit} content={this.state.delivery ? 'Actualizar':'Agregar'}/>
                    </Modal.Actions>
                </Modal>
            </React.Fragment>
        );
    }
}

function mapDispatchToProps(dispatch){
    return {
        showToast(data){
            dispatch(showToast(data))
        }
    }
}

export default connect(
    null,
    mapDispatchToProps
)(DeliveryOrder)



// WEBPACK FOOTER //
// ./src/components/sale/DeliveryOrder.js